export default __webpack_public_path__ + "static/media/Ballroll_00077.868a3c52.png";